let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Lrzu")).then(() => parcelRequire('1pN2h'));